/**
 * File main.js.
 *
 * Theme main script.
 *
 * Contains all theme custom features.
 */
export default (function($) {
    let ss = {
        init: function() {
            this.sponsorlevel();
            this.nav();
            this.form();
            this.slider();
            this.gallery();
            this.misc();
        },
        sponsorlevel: function() {

            var logo_count_plat = $('.page-template-tpl-sponsors-jpg .platinum .logos .logo').length;
            var logo_count_gold = $('.page-template-tpl-sponsors-jpg .gold .logos .logo').length;

            if (logo_count_plat == "0") {
                $('.page-template-tpl-sponsors-jpg .platinum').hide();
            }

            if (logo_count_gold == "0") {
                $('.page-template-tpl-sponsors-jpg .gold').hide();
            }

            if ((logo_count_plat % 3) != 0) {
                $('.page-template-tpl-sponsors-jpg .platinum .logos').addClass('justify-content-center');
            }

            if ((logo_count_gold % 3) != 0) {
                $('.page-template-tpl-sponsors-jpg .gold .logos').addClass('justify-content-center');
            }

            if (logo_count_plat == 4) {
                $('.page-template-tpl-sponsors-jpg .platinum .logos').removeClass('layout-3col').addClass('layout-2col');
            }

            if (logo_count_gold == 4) {
                $('.page-template-tpl-sponsors-jpg .gold .logos').removeClass('layout-3col').addClass('layout-2col');
            }

            var logo_count_silver = $('.page-template-tpl-sponsors-jpg .silver .logos .logo').length;
            var logo_count_partnr = $('.page-template-tpl-sponsors-jpg .partners .logos .logo').length;

            if (logo_count_silver == "0") {
                $('.page-template-tpl-sponsors-jpg .silver').hide();
            }

            if (logo_count_partnr == "0") {
                $('.page-template-tpl-sponsors-jpg .partners').hide();
            }

            if ((logo_count_silver % 4) != 0) {
                $('.page-template-tpl-sponsors-jpg .silver .logos').addClass('justify-content-center');
            }

            if ((logo_count_partnr % 4) != 0) {
                $('.page-template-tpl-sponsors-jpg .partners .logos').addClass('justify-content-center');
            }

            if (logo_count_silver == 5 || logo_count_silver == 6 || logo_count_silver == 9) {
                $('.page-template-tpl-sponsors-jpg .silver .logos').removeClass('layout-4col').addClass('layout-3col');
            }

            if (logo_count_partnr == 5 || logo_count_partnr == 6 || logo_count_partnr == 9) {
                $('.page-template-tpl-sponsors-jpg .partners .logos').removeClass('layout-4col').addClass('layout-3col');
            }

        },
        ie: function() {
            try {
                if (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                    $('body').addClass('ie-user');
                    return true;
                }
            } catch (err) {
                console.log(err);
            }
            return false;
        },
        nav: function() {
            $('.navbar-toggler').on('click', function() {
                $('body').toggleClass('active-nav');
                $(this).toggleClass('cross');
            });

            $('.backdrop').on('click', function() {
                $('body').removeClass('active-nav');
                $('.navbar-collapse').removeClass('show');
                $('.navbar-toggler').removeClass('cross');
            });

            // create and append 
            function dropdownArrow() {
                var arrow = $('<span class="dropdown-arrow icon-angle-left-lg"></span>');
                var nextElement = $('.nav-link.dropdown-toggle');
                arrow.insertAfter(nextElement);
            };
            dropdownArrow();

            // dropdown 
            $('.dropdown-arrow.icon-angle-left-lg').each(function() {
                $(this).on('click', function() {
                    $(this).toggleClass('active');
                    $(this).parent().find('.sub-menu').toggleClass('show');
                    $(this).parent().toggleClass('show');
                });
            });
        },
        form: function() {
            try {
                $('.input-text.qty').each(function() {
                    var elm = $(this);
                    $('<span class="qty-des"><i class="icon-angle-left"></i></span>').insertBefore($(this));
                    $('<span class="qty-ins"><i class="icon-angle-right"></i></span>').insertAfter($(this));
                    elm.prev('.qty-des').on('click', function() {
                        var val = parseInt(elm.val());
                        if (val > 1) {
                            elm.val(val - 1);
                        }
                    });
                    elm.next('.qty-ins').on('click', function() {
                        var val = parseInt(elm.val());
                        elm.val(val + 1);
                    });
                });

            } catch (err) {
                console.log(err);
            }
        },
        slider: function(context = null) {
            let $context = context ? $(context) : $('body');

            ($('.attendees__sliders').length > 0) && $('.attendees__sliders').on('setPosition', function() {
                $(this).find('.attendees__slide').height('auto');
                var slickTrack = $(this).find('.slick-track');
                var slickTrackHeight = $(slickTrack).height();
                $(this).find('.attendees__slide').css('height', slickTrackHeight + 'px');
            });

            ($context.find('.attendees__slider-video').length > 0) && $context.find('.attendees__slider-video').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.attendees__sliders',
            });

            ($context.find('.attendees__sliders').length > 0) && $context.find('.attendees__sliders').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: '.attendees__slider-video',
                focusOnSelect: true,
                nextArrow: '<button type="button" class="slick-next icon-angle-right"></button>',
                prevArrow: '<button type="button" class="slick-prev icon-angle-left"></button>',
                responsive: [{
                        breakpoint: 1599,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

            //News slider
            ($context.find('.news-slider').length > 0) && $context.find('.news-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                nextArrow: '<button type="button" class="slick-next news-slider__btn news-slider__next"><span class="icon-angle-right-md"></span></button>',
                prevArrow: '<button type="button" class="slick-prev news-slider__btn news-slider__prev"><span class="icon-angle-left-md"></span></button>',
                responsive: [{
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false
                        }
                    }
                ]
            });

            // Expo Slider
            ($context.find('.expo__slider').length > 0) && $context.find('.expo__slider').slick({
                rows: 2,
                slidesPerRow: 4,
                nextArrow: '<button type="button" class="slick-next icon-angle-right"></button>',
                prevArrow: '<button type="button" class="slick-prev icon-angle-left"></button>',
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        row: 2,
                        slidesPerRow: 2
                    },
                    breakpoint: 575,
                    settings: {
                        row: 2,
                        slidesPerRow: 1
                    }
                }]
            });

            ($context.find('.expert__slider').length > 0) && $context.find('.expert__slider').slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        dots: true
                    }
                }],
            });

            ($context.find('.expert__keynote').length > 0) && $context.find('.expert__keynote').slick({
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true
            });

            // Industries-img__slider
            ($context.find('.industries-slider').length > 0) && $context.find('.industries-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: false,
                nextArrow: '<button type="button" class="slick-next industries-slider__btn industries-slider__next"><span class="icon-angle-right-md"></span></button>',
                prevArrow: '<button type="button" class="slick-prev industries-slider__btn industries-slider__prev"><span class="icon-angle-left-md"></span></button>'
            });

            ($context.find('.experience .slick-slider').length > 0) && $context.find('.experience .slick-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                dots: false,
            });

            // expert-card__slider
            ($context.find('.expert-card__slider').length > 0) && $context.find('.expert-card__slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                dots: true,
                arrows: false,
            });

            // highlights-slider
            ($context.find('.highlights-slider').length > 0) && $context.find('.highlights-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                dots: false,
                nextArrow: '<button type="button" class="slick-next highlights-slider__btn highlights-slider__next"><span class="icon-angle-right-md"></span></button>',
                prevArrow: '<button type="button" class="slick-prev highlights-slider__btn highlights-slider__prev"><span class="icon-angle-left-md"></span></button>'
            });

            ($context.find('.exp-sliderr, .upc-sliderr').length > 0) && $context.find('.exp-sliderr, .upc-sliderr').slick({
                autoplay: true,
                autoplaySpeed: 0,
                speed: 7000,
                cssEase: 'linear',
                vertical: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                pauseOnHover: false,
                pauseOnFocus: false,
            });

            jQuery('.scrolling-sponsors-grid').marquee({

                // Set to false if you want to use jQuery animate method
                allowCss3Support: true,

                // CSS3 easing function
                css3easing: 'linear',

                // Requires jQuery easing plugin.
                easing: 'linear',

                // Time to wait before starting the animation
                delayBeforeStart: 2000,

                // 'left', 'right', 'up' or 'down'
                direction: 'up',

                // Should the marquee be duplicated to show an effect of continues flow
                duplicated: true,

                // Duration of the animation
                duration: 15000,

                // Space in pixels between the tickers
                gap: 20,

                // On cycle pause the marquee
                pauseOnCycle: false,

                // Pause on hover
                pauseOnHover: false,

                // The marquee is visible initially positioned next to the border towards it will be moving
                startVisible: false

            });

            var marqueItemCount = jQuery('.exp-slider .marque-start .slide-item, .upc-slider .marque-start .slide-item');

            if (marqueItemCount.length <= 2) {
                jQuery('.exp-slider .marque-start, .upc-slider .marque-start').addClass('marque-stop').removeClass('marque-start');
            }

            jQuery('.exp-slider .marque-start, .upc-slider .marque-start').marquee({

                // Set to false if you want to use jQuery animate method
                allowCss3Support: true,

                // CSS3 easing function
                css3easing: 'linear',

                // Requires jQuery easing plugin.
                easing: 'linear',

                // Time to wait before starting the animation
                delayBeforeStart: 0,

                // 'left', 'right', 'up' or 'down'
                direction: 'up',

                // Should the marquee be duplicated to show an effect of continues flow
                duplicated: true,

                // Duration of the animation
                duration: 60000,

                // Space in pixels between the tickers
                gap: 20,

                // On cycle pause the marquee
                pauseOnCycle: false,

                // Pause on hover
                pauseOnHover: false,

                // The marquee is visible initially positioned next to the border towards it will be moving
                startVisible: true

            });
        },
        gallery: function() {
            try {
                $('.fancybox').fancybox({
                    openEffect: 'none',
                    closeEffect: 'none',
                    clickContent: 'false'
                });

                $('.event-gallery').fancybox({});

            } catch (err) {
                console.log(err);
            }
            try {
                var fix = function() {
                    var t = $('.woocommerce-product-gallery__trigger'),
                        h = t.next('.flex-viewport').outerHeight() - 16;
                    t.height(h);
                }
                $(window).bind('load resize', fix);
                $('.woocommerce-product-gallery .flex-control-nav li').on('click', function() {
                    setTimeout(fix, 500);
                });
            } catch (err) {
                console.log(err);
            }
        },
        misc: function(context = null) {

            document.querySelectorAll('[data-hide-after-seconds]').forEach(function(item) {
                if (parseInt(item.getAttribute('data-hide-after-seconds')) > 0) {
                    setTimeout(function() {
                        item.style.display = "none";
                    }, parseInt(item.getAttribute('data-hide-after-seconds')) * 1000);
                }
            });

            document.querySelectorAll('[data-show-after-seconds]').forEach(function(item) {
                if (parseInt(item.getAttribute('data-show-after-seconds')) > 0) {
                    setTimeout(function() {
                        item.style.display = "block";
                    }, parseInt(item.getAttribute('data-show-after-seconds')) * 1000);
                }
            });

            //Sticky Form Button scripts
            function toggleStickyButton(){
                const form = document.querySelector('.hasStickyButton');
                const submitButton = document.querySelector('.hasStickyButton .sticky-button-wrap button');
                if(!form || !submitButton) return;
                const formRect = form.getBoundingClientRect();
                const formBottom = formRect.top + formRect.height;
                const viewportHeight = window.innerHeight;
                const isSticky = viewportHeight<formBottom
                if(isSticky){
                   submitButton.classList.add('sticky-button-bottom');
                }else{
                    submitButton.classList.remove('sticky-button-bottom');
                }
            }
            
            window.addEventListener('scroll', toggleStickyButton);
            window.addEventListener('resize', toggleStickyButton);
            /* End of the code block */

            let $context = context ? $(context) : $('body');
            try {

                // $(".column-height").matchHeight();
                $(".scrolltopCust").click(function(e) {
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });

                // remove class After completion of ajax load
                window.almComplete = function(alm) {

                    $('.news-item__text').matchHeight();
                    $('.news-item__text').removeClass('news-item__text--height');

                };

                if ($('.news-content').length) {
                    $('.news-content article .news-item>div').matchHeight({
                        byRow: false
                    });
                }

                $('[data-fix="height"], .exchange-cont').matchHeight();

                $('.banner-location__item').matchHeight({
                    byRow: false
                });

                $('.tour-table__body .item-height').matchHeight({
                    byRow: false
                });

                // sticky header 
                function stickyHeader() {
                    var height = $(window).scrollTop();
                    var header = $('.site-header');

                    if (height > 150) {
                        header.addClass('sticky');
                    } else {
                        header.removeClass('sticky');
                    }
                }

                $(window).scroll(stickyHeader);
                stickyHeader();

                $('.about-page .news-content article .news-item>div').matchHeight({
                    byRow: false
                });

                // custom tabs
                $('.nav.nav-tabs .nav-link').on('click', function(e) {

                    e.preventDefault();
                    // alert();
                    var currentParent = $(this).parent().parent().parent();
                    var target = $(this).attr('data-href');

                    // addClass to the current video wrapper
                    if (currentParent.hasClass('tab-row')) {
                        currentParent.find('.tab-pane.show.active').addClass('prev-video');
                    }

                    $(target).siblings().removeClass('show active');
                    $('.testimonial-video .nav-link').siblings().removeClass('active');

                    // remove only the active nav
                    currentParent.find('.nav-link').removeClass('active');

                    $(this).addClass('active');
                    $(target).addClass('show active');
                });

                // puase video on click 
                $('.testimonial-video__content .nav-link').each(function() {
                    $(this).on('click', function() {

                        // detect the prev Video
                        var prevVideo = $('.prev-video>iframe[src*="youtube"]');
                        var parent = prevVideo.parent().parent();

                        // stop video 
                        var src = prevVideo.attr('src');
                        prevVideo.attr('src', '');
                        prevVideo.attr('src', src);

                        // remove the class
                        parent.find('.tab-pane').removeClass('prev-video');
                    });
                });

                // smoothscroll 
                $('.smooth-scroll').on('click', function(e) {
                    e.preventDefault();
                    $('html, body').animate({
                            scrollTop: $($(this).attr('data-target')).offset().top,
                        },
                        400,
                        'linear'
                    );
                });

                //scrolltosection
                $(".scrolltosection").click(function(e) {
                    e.preventDefault();
                    var dataId = $(this).attr('data-id');
                    let sreenWidth = (window.innerWidth || document.documentElement.clientWidth);
                    if (dataId == 'schedule') {
                        if (sreenWidth <= 421) {
                            var offsetData = 130;
                        } else {
                            var offsetData = 165;
                        }
                    } else {
                        var offsetData = 135;
                    }
                    $('html, body').animate({
                        scrollTop: $("#" + dataId).offset().top - offsetData
                    }, 2000);
                });

                // counter
                if ($context.find('.counter').length) {
                    var waypoint = new Waypoint({
                        element: $context.find('.counter'),
                        handler: function(direction) {},
                    });

                    $context.find('.counter').counterUp({
                        delay: 10,
                        time: 1500
                    });
                }

                function StopEmbedVideo() {
                    var $frame = $('#embedvideo');

                    // saves the current iframe source
                    var vidsrc = $frame.attr('src');

                    // sets the source to nothing, stopping the video
                    $frame.attr('src', '');

                    // sets it back to the correct link so that it reloads immediately on the next window open
                    $frame.attr('src', vidsrc);

                }

                // Pause video
                $('.close , .modal-backdrop').click(function() {
                    $('.modal').removeClass('show');
                    StopEmbedVideo();
                });

                // min max random int generate
                function getRandomInt(min, max) {
                    return Math.floor(Math.random() * (max - min + 1) + min);
                }

                ($context.find('.experience__slide').length > 0) && $context.find('.experience__slide').slick({
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 7000,
                    pauseOnHover: false
                });

                var stickyDiv = $('.partner__left-wrap');

                function stickyTab() {
                    var stickyTop = $('.partner__left-wrap').offset().top;
                    var stickyHeight = stickyDiv.height();
                    var stickyWidth = $(".partner__left").outerWidth() - 30;

                    $(window).on("resize", function() {
                        stickyWidth = $(".partner__left").outerWidth() - 30;
                        stickyDiv.css("width", stickyWidth + "px");
                    });

                    $(window).on("scroll", function() {
                        var windowTop = $(window).scrollTop();
                        var parentDivTop = $('.partner-section').offset().top;
                        var parentHeight = $('.partner-section').height();

                        if (stickyTop < windowTop &&
                            parentHeight + parentDivTop - (stickyHeight + 120) > windowTop) {
                            stickyDiv.css('top', (windowTop - parentDivTop + 95) + 'px');
                            stickyDiv.addClass('sticky');
                            stickyDiv.css("width", stickyWidth + "px");
                        } else {
                            stickyDiv.removeClass('sticky');
                            stickyDiv.css('top', 0);
                        }
                    })
                }
                if (!!stickyDiv.offset()) {
                    stickyTab();
                }

                $('#live-virtual-toggler').on('click', function() {
                    $(this).toggleClass('virtual');
                    $(this).hasClass('virtual') ? $(this).text('Go Virtual!') : $(this).text('Go Live!');
                });

                // var appendText = function() {
                //     if ($(".reister-form-banner .default-form").find(".policy-text")) {
                //         var clonedNode = $(".reister-form-banner .default-form").find(".policy-text").clone();
                //         $(".reister-form-banner .default-form").append(clonedNode);
                //     }
                // };
                //appendText();
            } catch (err) {
                console.log(err);
            }

            setTimeout(function () {
                var winWidth = jQuery(window).width();
                jQuery('a.js-has-smooth-scroll[href*="#"]:not([href="#"])').click(function () {
                    if (
                        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                        location.hostname == this.hostname
                    ) {
                        var target = jQuery(this.hash);
                        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
                        if (target.length) {
                            if (winWidth > 991) {
                                jQuery('html, body').animate(
                                    {
                                        scrollTop: target.offset().top - 50,
                                    },
                                    1000
                                );
                            } else {
                                jQuery('html, body').animate(
                                    {
                                        scrollTop: target.offset().top,
                                    },
                                    1000
                                );
                            }
                            return false;
                        }
                    }
                });
            }, 3000);
        },
    };
    return ss;
})(jQuery);

// Vimeo player
var vimeoIframe = document.getElementById('virtual-video');

if (vimeoIframe) {
    var player = new Vimeo.Player(vimeoIframe);
    var playerBtn = document.querySelector(".iframe-demo__button");

    playerBtn.addEventListener('click', function() {
        player.play();
    });

    player.on('play', function(event) {
        playerBtn.classList.add("hide");
    });

    player.on('pause', function(event) {
        playerBtn.classList.remove("hide");
    });
}